// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","769":"component---src-templates-project-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"f4b5ab22a1d02080ce44","769":"8af1189ebba19fa9ef26","883":"43949db642f938c16a4e"}[chunkId] + ".js";
};